export default __webpack_public_path__ + "static/media/icon-warranty.52d305ee.svg";